import type { MetricColumn } from './useColumnVisibility'

/** The shape this reads off a Top Posts row — structural, so tests need no fixture. */
type PostWithMetrics = {
  metrics?: ReadonlyArray<{ type: string; name: string }> | null
}

/**
 * The metric columns the Top Posts table can offer, taken from the rows the
 * server returned.
 *
 * **The column set changes with the post type filter, and that is correct.** A
 * Story reports fewer metrics than a feed post — `FacebookMetricDefinitions` and
 * `InstagramMetricDefinitions` branch on the stored format and drop the
 * engagement rate, among others — so filtering to Stories legitimately removes
 * columns that had nothing to show. Deriving the set from the response rather
 * than from a fixed list is what keeps an empty column from appearing.
 *
 * Duplicates across rows are expected; {@link useColumnVisibility} dedupes by
 * `type`, keeping first occurrence, so the order follows the first row that
 * reports each metric.
 */
export function postMetricColumns(
  posts: ReadonlyArray<PostWithMetrics>,
): MetricColumn[] {
  return posts.flatMap(
    (post) =>
      post.metrics?.map((metric) => ({
        type: metric.type,
        displayName: metric.name,
      })) ?? [],
  )
}
